module.exports = __webpack_public_path__ + "img/Master Guardian.a51a5681.png";